import type { UserRegionRef } from '../userViewModel';

import RegionChip from './RegionChip';

interface UserRegionChipsProps {
  regions: UserRegionRef[];
  /** Regions outside this set render locked/dimmed. Null leaves every chip open. */
  manageableRegionIds?: string[] | null;
  max?: number;
}

/** Renders a user's region badges. "Global" when none. When `manageableRegionIds`
 *  is given, regions outside that set render locked. */
export default function UserRegionChips({
  regions,
  manageableRegionIds = null,
  max = 4,
}: UserRegionChipsProps) {
  if (!regions.length) {
    return <span className="text-[11.5px] text-stone-400 dark:text-stone-500">Global</span>;
  }
  const show = regions.slice(0, max);
  const overflow = regions.length - show.length;
  return (
    <div className="flex gap-1 flex-wrap">
      {show.map((r) => (
        <RegionChip
          key={r.id}
          region={r}
          locked={manageableRegionIds ? !manageableRegionIds.includes(r.id) : false}
        />
      ))}
      {overflow > 0 && (
        <span className="inline-flex items-center h-5 px-1.5 text-[10.5px] font-semibold text-stone-600 dark:text-stone-400">
          +{overflow}
        </span>
      )}
    </div>
  );
}
